export default __webpack_public_path__ + "1eed4e917817522b27592e34f0d6adfe.png";